import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-dial-numbers-icon',
  templateUrl: './communication-dial-numbers.component.html'
})
export class CommunicationDialNumbersComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
